export default __webpack_public_path__ + "static/media/pencil.15d355de.svg";